import { mount } from "svelte";
import AddToCampaignModal from "../modals/AddToCampaign/AddToCampaignModal.svelte";
import { addToCampaignModalStore } from "../modals/AddToCampaign/stores";

export const bindAddToCampaignModal = () => {
  const target = document.getElementById("addToCampaignModal");
  return mount(AddToCampaignModal, {
    target,
  });
};

export const openAddToCampaignModal = (candidates) => {
  addToCampaignModalStore.set({ candidates });
};
